import {catchError} from 'rxjs/operators';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, UtilsService } from '../../xform-compat';


/**
 * Injectable abstract class service for general CRUD operations
 */
@Injectable()
export abstract class RmsBasicCrudService<T> implements OnInit {

  protected constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private exceptionService: ExceptionService
  ) { }

  ngOnInit(): void {}

  protected getHttp () {
    return this.http;
  }

  protected getExceptions () {
    return this.exceptionService;
  }

  /**
   * Gets data from the API
   * @param {string} url
   * @param params
   * @returns {Observable<T>}
   */
  public getData (url: string, params?: any): Observable<T> {
    const httpParams: HttpParams = this.utilsService.generateParams(params);
    return this.http.get(url, {params: httpParams}).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Creates new record sending data to the API
   * @param {string} url
   * @param {T} body
   * @returns {Observable<T>}
   */
  public saveData (url: string, body: T): Observable<T> {
    return this.http.post(url, body).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Updates a record
   * @param {string} url
   * @param {T} body
   * @returns {Observable<T>}
   */
  public updateData (url: string, body: T): Observable<T> {
    return this.http.put(url, body).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

  /**
   * Deletes a record
   * @param {string} url
   * @returns {Observable<T>}
   */
  public deleteData (url: string): Observable<T> {
    return this.http.delete(url).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
